import styled, { css } from 'styled-components';
import typography from 'src/utils/typography';

export const ModalContent = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s6};
    display: flex;
    flex-direction: column;
  `,
);

export const TextWrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s6};
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${typography.heading.mobile.m};
    margin-bottom: ${theme.sz.s4};
  `,
);

export const ButtonsWrapper = styled.div<{ $isFlexEnd: boolean }>(
  ({ theme, $isFlexEnd }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.sz.s6};
    align-self: ${$isFlexEnd && 'flex-end'};

    @media (max-width: ${theme.sz.ms}) {
      flex-direction: column;
      gap: ${theme.sz.s3};
    }
  `,
);
